module.exports = "/assets/839437145ee3c9e199edb0de6801e82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/P1.png
// module id = 2824
// module chunks = 0